import { request } from "@/interface/helper";

const str = "communityCommunity";

export const communityCommunity = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/community/list" }),
    add: data => request({ data, method: "post", url: "/community/community/add" }),
    detail: data => request({ data, method: "post", url: "/community/community/detail" }),
    edit: data => request({ data, method: "post", url: "/community/community/modify" }),
    userList: data => request({ data, method: "get", url: "/community/community/userList" }),
  }
};
